import resetRowIndexes from "./reset-row-indexes"

export default function(e) {
	e.stopPropagation()
	e.preventDefault()

	// remove this row
	const target = e.target.closest('.row')
	const repeater = e.target.closest('.repeater-container')

debugger
	if (target) {
		target.remove()
		resetRowIndexes(repeater.querySelector('.rows'))
	} else {
		console.warn('Error deleting row')
	}
}
